export default __webpack_public_path__ + "static/media/logo_negro.25f93af7.png";